var _defs, _circle, _polygon, _polygon2, _polygon3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAgriservice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.842mm",
    height: "5.842mm",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#009846}\n    .fil1 {fill:#FEFEFE}\n    .fil2 {fill:#009846;fill-rule:nonzero}\n  "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 16,
    cy: 16,
    r: 16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "8 18 24 18 24 7 8 7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "5 24 27 24 24 19 8 19"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "13 23 19 23 19 23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m16 10v-1h1v1h-1zm0 5v-5h1v5h-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAgriservice);
export default __webpack_public_path__ + "static/media/menu-agriservice.9e5c9aefa50324173c504ead7296ec1b.svg";
export { ForwardRef as ReactComponent };